import styled from "styled-components"
import { theme } from "../../../../styles/theme"
import { MouseEventHandler } from "react"
import { GetDailyDrivingListParams, HistoryDailyDriving } from "../../../../types"
import { useGetDailyDrivingList } from "../../../../api/history"

interface Props {
  apiParams: GetDailyDrivingListParams
  drivingId?: number,
  date?: string,
  onEvent?: (e: any) => any
}

export const Section_History_DailyDrivings = ({apiParams, drivingId, date, onEvent}: Props) => {
  const {data: list} = useGetDailyDrivingList(apiParams)

  const onClick: MouseEventHandler = e => {
    const newDrivingId = Number.parseInt((e.target as HTMLElement)?.dataset.drivingId ?? "")
    if (newDrivingId > 0)
    if (newDrivingId !== drivingId)
    onEvent?.({
      event: "click",
      type: "driving",
      data: {drivingId: newDrivingId}
    })
  }

  return (
    <SSection className="DailyDrivings">
      <header>
        <label>주행기록</label>
        <strong>{date || "-"}</strong>
      </header>

      <ul className="SCROLL_BG_TRANS" onClick={onClick}>
        {list?.map(({id, driveType, result, startTimePart, endTimePart}) => {
          const type = Number(driveType) == 1 ? "driving" : "parking"
          const active = id == drivingId

          return (
            <li className={active ? "active" : ""} key={id} data-driving-id={id}>
              <label className={type}>{result}</label>
              <div className="times">{startTimePart} ~ {endTimePart}</div>
            </li>
          )
        })}
      </ul>
    </SSection>
  )
}

const SSection = styled.section`
  grid-template-rows: min-content 1fr;

  & > ul {
    display: grid;
    align-content: start;
    overflow-x: hidden;
    overflow-y: auto;
  
    & > li {
      display: flex;
      align-items: center;
      gap: 10px;
      cursor: pointer;
      white-space: nowrap;
      padding: 5px;
      margin-right: 10px;

      & * {
        pointer-events: none;
      }
      & > label {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 6px;
        font-size: 14px;
        background-color: ${theme.colors.black_bg};
        height: 24px;
        border-radius: 12px;
        padding: 0 8px;

        &::before {
          content: "";
          width: 8px;
          height: 8px;
          border-radius: 50%;
        }
        &.driving {
          color: skyblue;
          &::before {
            background-color: skyblue;
          }
        }
        &.parking {
          color: orange;
          &::before {
            background-color: orange;
          }
        }
      }
      &.active, &:hover {
        background-color: ${theme.colors.green};
      }
    }
  }
`